
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify'
import GetCampaignURL from '../../Services/Queries/GetCampaignURL';




export default function CreateCampaign() {
	const toastStyle = {
		position: 'top-right',
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}

	const [url, setUrl] = useState('');
	const [shortUrl, setShorturl] = useState('');
	const [longUrl, setLongurl] = useState('');
	function handleInputURl(value) {
		setUrl(value)
		console.log(value, 'here is the value ')

	}
	function checkCopied() {
		console.log('inside checkcopied')
		toast.success('Copied Successfully', toastStyle);
	}
	const postToService = async () => {
		console.log('hello inside service')
		const input = {
			URL: url,
		}
		const data = await GetCampaignURL(input)
		console.log(data, 'here is the response for campaign')
		setShorturl(data.URL)
		setLongurl(data.mainURL)


	}

	return (



		<div>
			<ToastContainer
				position='top-right'
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			{/* {console.log(data,'here is the response')} */}
			<label>URL :</label>
			<input
				type='text'
				onChange={(e) => {
					handleInputURl(e.target.value)
				}}
				value={url}
				placeholder='Please Enter URL'
			></input>
			<br></br>
			<div>
				<button onClick={postToService} type="button" class="btn btn-primary"

				>submit</button>
			</div>

			<div>
				{shortUrl && (<div>
					<label>Short URL :</label>
					<div>
						{shortUrl}
					</div>
					<div class="copybutton" onClick={() => checkCopied()}>
						<CopyToClipboard text={shortUrl}  >

							<text >
								<i class="fa fa-copy" ></i>
							</text>
						</CopyToClipboard>

					</div>
				</div>
				)}
			</div>
			<div>
				{longUrl && (<div>
					<label>Long URL :</label>
					<div>
						{longUrl}
					</div>
					<div class="copybutton2" onClick={() => checkCopied()}>
						<CopyToClipboard text={longUrl}  >
							<text >
								<i class="fa fa-copy" ></i>
							</text>
						</CopyToClipboard>

					</div>
				</div>
				)}
			</div>
		</div>

	)

}